import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import Api from "../../services/api";
import swal from "sweetalert";
import SelectCidades from "../../components/SelectCidades";

const image_formats = ["image/jpg", "image/jpeg", "image/png", "image/webp"];

export default function NewMidia({ loadMidia, setOpenModalNew }) {
  const [loading, setLoading] = useState(false);
  const Loader = () => <div className="loading"></div>;
  const [tipo, setTipo] = useState("foto");
  const [cidadeId, setCidadeId] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [legenda, setLegenda] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!cidadeId) return setError("Cidade obrigatória.");

    const body = new FormData();
    body.append("cidade_id", cidadeId);
    body.append("tipo", tipo);
    body.append("legenda", legenda);

    if (tipo === "foto") {
      const fileInput = document.querySelector("#arquivo");
      const file = fileInput && fileInput.files[0];
      if (!file) return setError("Selecione uma imagem.");
      if (file.size > 5 * 1024 * 1024)
        return setError("Imagem maior que 5MB.");
      if (!image_formats.includes(file.type))
        return setError("Formato inválido (jpg, png, webp).");
      body.append("arquivo", file);
    } else {
      if (!videoUrl || !/^https?:\/\//i.test(videoUrl))
        return setError("URL de vídeo inválida.");
      body.append("video_url", videoUrl);
    }

    setLoading(true);
    Api.post("/albatrozmidia/new", body, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        if (response.data.status === "success") {
          swal("Sucesso!", response.data.message, "success");
          loadMidia();
          setOpenModalNew(false);
        } else {
          swal("Erro!", response.data.message || "Erro", "error");
        }
        setLoading(false);
      })
      .catch((err) => {
        swal("Erro!", "ops! ocorreu um erro: " + err, "error");
        setLoading(false);
      });
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <h2>Nova mídia</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <Grid container className="form">
          <Grid item lg={12} md={12} sm={12} xs={12} className="field">
            <label>Cidade</label>
            <SelectCidades
              register={{ name: "cidade_id" }}
              handleChange={(e) => setCidadeId(e.target.value)}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12} className="field">
            <label>Tipo</label>
            <div style={{ display: "flex", gap: 16 }}>
              <label>
                <input
                  type="radio"
                  name="tipo"
                  value="foto"
                  checked={tipo === "foto"}
                  onChange={() => setTipo("foto")}
                />{" "}
                Foto
              </label>
              <label>
                <input
                  type="radio"
                  name="tipo"
                  value="video"
                  checked={tipo === "video"}
                  onChange={() => setTipo("video")}
                />{" "}
                Vídeo (URL)
              </label>
            </div>
          </Grid>
          {tipo === "foto" ? (
            <Grid item lg={12} md={12} sm={12} xs={12} className="field">
              <label>Imagem</label>
              <p>(Recomendado: 1280x720 ou similar 16:9)</p>
              <input type="file" name="arquivo" id="arquivo" />
            </Grid>
          ) : (
            <Grid item lg={12} md={12} sm={12} xs={12} className="field">
              <label>URL do vídeo (YouTube, Vimeo, mp4...)</label>
              <input
                type="text"
                placeholder="https://www.youtube.com/watch?v=..."
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
              />
            </Grid>
          )}
          <Grid item lg={12} md={12} sm={12} xs={12} className="field">
            <label>Legenda (opcional)</label>
            <input
              type="text"
              value={legenda}
              onChange={(e) => setLegenda(e.target.value)}
            />
          </Grid>
          {error && <span className="error">{error}</span>}
        </Grid>
        <div className="actions">
          <button type="submit" className="save">
            Salvar
          </button>
          <a
            href="#"
            className="cancel"
            onClick={(e) => {
              e.preventDefault();
              setOpenModalNew(false);
            }}
          >
            Cancelar
          </a>
        </div>
      </form>
    </>
  );
}
